import cardGrid from '../../styles/card-grid.module.css';
import BusinessCard, { CardRenderableBusiness } from './card';

interface Props {
  businesses: (CardRenderableBusiness & { id: string | number })[];
}

const BusinessCardGrid: React.FC<Props> = ({ businesses }) => (
  <div className={cardGrid.cardGrid}>
    {businesses.map(business => (
      <BusinessCard business={business} key={business.id} />
    ))}
  </div>
);

export default BusinessCardGrid;
